export function initReceiptDelivery(root = document) {
    root.querySelectorAll('[data-receipt-delivery]').forEach((form) => {
        const phone = form.elements.receipt_phone;
        const email = form.elements.receipt_email;
        const consent = form.elements.receipt_consent;
        const normalizePhone = () => {
            const number = phone.value.replace(/[\s()+-]/g, '').replace(/^8/, '7');
            phone.value = '+' + (number || '7');
        };
        const update = () => {
            const mcho = form.elements.receipt_method.value === 'mcho';
            const accepted = Boolean(form.dataset.acceptedPhone)
                && phone.value.replace(/[\s()+-]/g, '') === form.dataset.acceptedPhone;
            form.querySelector('[data-receipt-mcho]').hidden = !mcho;
            form.querySelector('[data-receipt-email]').hidden = mcho;
            form.querySelector('[data-receipt-consent]').hidden = accepted;
            form.querySelector('[data-receipt-accepted]').hidden = !accepted;
            phone.disabled = !mcho;
            phone.required = mcho;
            email.disabled = mcho;
            email.required = !mcho;
            consent.disabled = !mcho || accepted;
            consent.required = mcho && !accepted;
        };
        form.addEventListener('change', update);
        phone.addEventListener('input', () => {
            normalizePhone();
            consent.checked = false;
            update();
        });
        normalizePhone();
        update();
    });
}
